import {AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-doc-api',
  standalone: true,
  templateUrl: './doc-api.component.html',
  styleUrls: ['./doc-api.component.scss']
})

export class DocApiComponent implements AfterViewInit {
  @ViewChild('apiDocFrame') iframe: ElementRef<HTMLIFrameElement>;

  ngAfterViewInit() {
    const iframe = this.iframe.nativeElement;
    let messageSent = false;
    
    iframe.addEventListener('load', () => {
        const targetOrigin = environment.environment == 'rec2' ? new URL(environment.docsBucketUrl).origin  : new URL(environment.docApiServerUrl).origin;
        if (!messageSent) {
            iframe.contentWindow?.postMessage({
                type: 'API_URL',
                apiUrl: environment.docApiServerUrl
            }, targetOrigin);
            messageSent = true;
        }
    });
  }

}
